import { useState, useEffect } from 'react'
import { getTenant, getToken } from '../../../utils'
import Spinner from '../../Spinner/Spinner'

export default function ActiveCasesPDF({ location }) {
  console.log('PDFControls rendered')
  const tenant = getTenant()
  const [jwt, setJwt] = useState()
  
  useEffect(() => {
    function tokenSuccess(jwt) {
      setJwt(jwt)
    }
    function tokenError(error) {
      console.log('in token error', error)
    }
    getToken(tokenSuccess, tokenError)
  }, [])

  if (jwt) {
    let caseId = ''
    if (location.search) {
      const params = new URLSearchParams(location.search)
      caseId = params.get('caseId')
    }
    return (
      <div style={{
        display: 'inline',
        //position: 'absolute',
        top: '0px',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }} height="100%">
        <iframe title="bottom" width="100%" height="100%" src={`${process.env.REACT_APP_SERVER}/pdf/${tenant}/custom/CatEast/activeCaseFullReportPDF/active_case_full_report.pdf?caseId=${caseId}&jwt=${jwt}`} ></iframe>
      </div>
    )
  } else {
    return <Spinner />
  }
}